module.exports = __webpack_public_path__ + "static/media/project3.612dc9d2.jpg";